
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.41 13.267c.843 0 1.574-.303 2.17-.9.598-.597.9-1.327.9-2.171 0-.844-.303-1.574-.9-2.171a2.972 2.972 0 0 0-2.17-.9c-.845 0-1.575.303-2.172.9a2.972 2.972 0 0 0-.9 2.17c0 .845.303 1.575.9 2.172.597.597 1.328.9 2.171.9Zm5.373 3.662a7.572 7.572 0 0 0-.104-.805 6.35 6.35 0 0 0-.198-.81 3.993 3.993 0 0 0-.333-.756 2.847 2.847 0 0 0-.502-.654 2.213 2.213 0 0 0-.721-.454c-.28-.11-.59-.166-.921-.166-.13 0-.256.053-.5.211-.172.113-.345.225-.52.336a2.972 2.972 0 0 1-.672.296 2.67 2.67 0 0 1-.823.133c-.273 0-.55-.045-.823-.133a2.97 2.97 0 0 1-.672-.296 67.927 67.927 0 0 1-.52-.336c-.243-.158-.37-.211-.5-.211a2.49 2.49 0 0 0-.92.167c-.28.11-.523.263-.721.453a2.85 2.85 0 0 0-.502.654c-.139.244-.25.498-.333.756-.08.249-.147.521-.198.81a7.558 7.558 0 0 0-.104.805c-.017.251-.025.502-.025.753 0 .666.211 1.205.629 1.602.412.392.957.591 1.62.591h6.14c.662 0 1.207-.199 1.62-.59.417-.398.628-.937.628-1.603 0-.257-.008-.51-.025-.753Z"}}),_c('path',{attrs:{"d":"M21.98 6.455a.41.41 0 0 0-.33-.278l-2.614-.38-1.169-2.369a.41.41 0 0 0-.734 0l-1.169 2.369-2.614.38a.41.41 0 0 0-.226.698l1.891 1.843-.447 2.604a.409.409 0 0 0 .594.43l2.338-1.228 2.338 1.229a.41.41 0 0 0 .59-.454l-.443-2.581 1.891-1.843a.41.41 0 0 0 .104-.42Z"}})])
          )
        }
      }
    